import React from 'react';

import {
  Box,
  useColorModeValue,
  useDisclosure,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import Header from '../../Components/Header';
import PageHeader from '../../Components/Header/PageHeader';
import Inbox from '../../Components/conversations/Inbox.js';
import ThreadsArea from '../../Components/conversations/ThreadsArea.js';
import ContactInfo from '../../Components/conversations/ContactInfo.js';

const Conversations = () => {
  const bgColor = useColorModeValue('white.primary', 'blue.primary');
  return (
    <Box
      w={{ xl: '85%', lg: '85%', md: '100%', sm: '100%' }}
      height="100%"
      bg={bgColor}
      px="5"
      position="relative"
    >
      <Header />
      <PageHeader title="Conversations" />

      <Grid templateColumns="repeat(4, 1fr)" height="83vh">
        <GridItem colSpan={1}>
          <Box height="">
            <Inbox />
          </Box>
        </GridItem>
        <GridItem
          colSpan={2}
          borderLeft="solid 1px grey"
          borderRight="solid 1px grey"
          position="relative"
        >
          <Box height="">
            <ThreadsArea />
          </Box>
        </GridItem>
        <GridItem colSpan={1}>
          <Box height="100%">
            <ContactInfo />
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default Conversations;
